import { render, staticRenderFns } from "./Normativity.vue?vue&type=template&id=af3a2934&lang=pug&"
import script from "./Normativity.vue?vue&type=script&lang=js&"
export * from "./Normativity.vue?vue&type=script&lang=js&"
import style0 from "./Normativity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports